<template>
  <div class="view-tabs">
    <span class="view-tabs__label">视图周期：</span>
    <div class="view-tabs__btns">
      <a-button
        :type="state.viewMode === 'rolling' ? 'primary' : 'default'"
        @click="state.switchView('rolling')"
      >
        当前四周滚动
      </a-button>
      <div v-if="state.viewMode === 'rolling'" class="view-tabs__nav">
        <left-outlined class="view-tabs__arrow" @click="state.prevQuarter()" />
        <right-outlined class="view-tabs__arrow" @click="state.nextQuarter()" />
      </div>
      <a-button
        v-for="q in 4"
        :key="q"
        :type="
          state.viewMode === 'quarter' && state.activeQuarter === q
            ? 'primary'
            : 'default'
        "
        @click="state.switchView('quarter', q)"
      >
        {{ state.currentYear }}-Q{{ q }} 视图
      </a-button>
    </div>
    <div class="view-tabs__right">
      <a v-if="state.viewMode === 'rolling'">当前四周滚动数据 (PV)</a>
    </div>
  </div>
</template>

<script>
import { inject } from 'vue'
import { LeftOutlined, RightOutlined } from '@ant-design/icons-vue'

export default {
  name: 'ViewTabs',
  components: {
    LeftOutlined,
    RightOutlined
  },
  setup() {
    const state = inject('initState')
    return { state }
  }
}
</script>

<style lang="scss" scoped>
.view-tabs {
  display: flex;
  align-items: center;
  margin-bottom: 16px;

  &__label {
    white-space: nowrap;
    margin-right: 8px;
    color: #666;
  }

  &__btns {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &__nav {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  &__arrow {
    cursor: pointer;
    color: #999;
    font-size: 12px;
    padding: 4px;

    &:hover {
      color: #1890ff;
    }
  }

  &__right {
    margin-left: auto;

    a {
      color: #1890ff;
      font-size: 13px;
    }
  }
}
</style>
